import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { IBlockProps } from '~/types/template'

import './styles.scss'

const FrameBackgroundBlock = ({ className, color, onClick }: IBlockProps): ReactElement => {
  const classes = classNames('block frame-background-block', className)

  return <div className={classes} onClick={onClick} style={{ background: color }} />
}

export default FrameBackgroundBlock
